module.exports = __webpack_public_path__ + "3be577d7fe9e519e42cada323de6475d.glb";